import React, { useState, useCallback, useEffect, useRef } from 'react';
import { useLang, useTheme, fmt, Stars, Notif, useQueue, useFavMap } from '../App';
import { ADMIN_USERS } from '../constants/mockData';

// ─────────────────────────────────────────────────────────────
// ADMIN PANEL
// ─────────────────────────────────────────────────────────────
export const AdminPanel = () => {
  const { t, lang } = useLang();
  const at = t.admin;
  const [users, setUsers] = useState(ADMIN_USERS);
  const [tab, setTab] = useState("users");
  const [search, setSearch] = useState("");
  const [notif, setNotif] = useState(null);
  const notify = msg => { setNotif(msg); setTimeout(() => setNotif(null), 3000); };

  const toggleBan = id => {
    setUsers(us => us.map(u => u.id === id ? { ...u, status: u.status === "banned" ? "active" : "banned" } : u));
    notify(lang === "ru" ? "Статус обновлён" : "User status updated");
  };
  const changeRole = (id, role) => {
    setUsers(us => us.map(u => u.id === id ? { ...u, role } : u));
    notify(lang === "ru" ? "Роль обновлена" : "Role updated");
  };
  const filtered = users.filter(u => u.username.toLowerCase().includes(search.toLowerCase()));

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 18 }}>
      {notif && <Notif msg={notif} onClose={() => setNotif(null)} />}
      <div className="fu" style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <div>
          <h2 className="syne" style={{ fontSize: 22, fontWeight: 800 }}>⚙ {at.title}</h2>
          <p style={{ fontSize: 12, color: "var(--muted)", marginTop: 2 }}>{at.subtitle}</p>
        </div>
        <span className="tag" style={{ background: "rgba(248,113,113,0.12)", borderColor: "rgba(248,113,113,0.3)", color: "#f87171" }}>
          🔒 {at.adminOnly}
        </span>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(140px,1fr))", gap: 12 }} className="fu d1">
        {[
          { l: lang === "ru" ? "Пользователей" : "Total Users", v: "1,204,832", icon: "👥", c: "var(--a)" },
          { l: lang === "ru" ? "Активно сегодня" : "Active Today", v: "84,291", icon: "🟢", c: "#68d891" },
          { l: lang === "ru" ? "Карт" : "Maps Indexed", v: "214,930", icon: "♪", c: "#7eb8f7" },
          { l: "API Calls/s", v: "12,450", icon: "⚡", c: "var(--amber)" },
        ].map(s => (
          <div key={s.l} className="card" style={{ padding: "16px 18px" }}>
            <div style={{ fontSize: 20, marginBottom: 6 }}>{s.icon}</div>
            <div className="mono" style={{ fontSize: 18, fontWeight: 700, color: s.c }}>{s.v}</div>
            <div style={{ fontSize: 11, color: "var(--muted)", marginTop: 2 }}>{s.l}</div>
          </div>
        ))}
      </div>

      <div className="fu d2" style={{ display: "flex", gap: 8 }}>
        {[["users", "👥 " + at.users], ["settings", "⚙ " + at.settings], ["logs", "📋 " + at.logs]].map(([id, label]) => (
          <button key={id} onClick={() => setTab(id)} className={tab === id ? "btn-accent" : "btn-ghost"}
            style={{ padding: "7px 18px", fontSize: 12, borderRadius: 9 }}>
            {label}
          </button>
        ))}
      </div>

      {tab === "users" && (
        <div className="card fu d3">
          <div style={{ padding: "14px 18px", borderBottom: "1px solid var(--border)", display: "flex", gap: 10, alignItems: "center" }}>
            <input placeholder={`🔍 ${lang === "ru" ? "Поиск пользователей" : "Search users"}…`} value={search}
              onChange={e => setSearch(e.target.value)} style={{ padding: "7px 12px", flex: 1 }} />
            <span style={{ fontSize: 12, color: "var(--muted)" }}>{filtered.length} {lang === "ru" ? "польз." : "users"}</span>
          </div>
          <table>
            <thead><tr>
              <th>{lang === "ru" ? "Игрок" : "User"}</th><th>PP</th>
              <th>{lang === "ru" ? "Рейтинг" : "Rank"}</th>
              <th>{lang === "ru" ? "Роль" : "Role"}</th>
              <th>{lang === "ru" ? "Статус" : "Status"}</th>
              <th>{lang === "ru" ? "Действия" : "Actions"}</th>
            </tr></thead>
            <tbody>
              {filtered.map(u => (
                <tr key={u.id}>
                  <td>
                    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                      <div style={{
                        width: 30, height: 30, borderRadius: "50%", background: "var(--grad)",
                        display: "flex", alignItems: "center", justifyContent: "center",
                        fontSize: 13, color: "var(--bg)", fontWeight: 700, flexShrink: 0
                      }}>{u.username[0].toUpperCase()}</div>
                      <div>
                        <div style={{ fontWeight: 600, fontSize: 13 }}>{u.username}</div>
                        <div style={{ fontSize: 11, color: "var(--muted)" }}>{u.country} · {fmt(u.plays)} {lang === "ru" ? "игр" : "plays"}</div>
                      </div>
                    </div>
                  </td>
                  <td><span className="mono" style={{ color: "var(--a)", fontWeight: 700, fontSize: 12 }}>{fmt(Math.round(u.pp))}</span></td>
                  <td className="mono" style={{ fontSize: 12 }}>#{fmt(u.rank)}</td>
                  <td>
                    <select value={u.role} onChange={e => changeRole(u.id, e.target.value)} style={{ padding: "3px 8px", fontSize: 11 }}>
                      {["User", "Moderator", "Admin"].map(r => <option key={r}>{r}</option>)}
                    </select>
                  </td>
                  <td>
                    <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
                      <span className={`sdot dot-${u.status}`} />
                      <span style={{ fontSize: 12, textTransform: "capitalize" }}>{u.status}</span>
                    </span>
                  </td>
                  <td>
                    <button onClick={() => toggleBan(u.id)} style={{
                      padding: "3px 12px", borderRadius: 7, border: "1px solid", fontSize: 11, fontWeight: 600, cursor: "pointer", fontFamily: "inherit",
                      borderColor: u.status === "banned" ? "rgba(104,216,145,0.4)" : "rgba(248,113,113,0.4)",
                      background: u.status === "banned" ? "rgba(104,216,145,0.1)" : "rgba(248,113,113,0.1)",
                      color: u.status === "banned" ? "#68d891" : "#f87171",
                    }}>{u.status === "banned" ? (lang === "ru" ? "Разбан" : "Unban") : (lang === "ru" ? "Бан" : "Ban")}</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {tab === "settings" && (
        <div className="card fu d3" style={{ padding: 26 }}>
          <h3 className="syne" style={{ fontWeight: 700, marginBottom: 18, color: "var(--a3)", fontSize: 14 }}>
            {lang === "ru" ? "Системные настройки" : "System Configuration"}
          </h3>
          {[
            [lang === "ru" ? "Лимит API (запросов/мин)" : "API Rate Limit (req/min)", "60", "number"],
            [lang === "ru" ? "Макс. PP для рекомендаций" : "Max PP for Recommendations", "600", "number"],
            [lang === "ru" ? "Мин. PP для рекомендаций" : "Min PP for Recommendations", "100", "number"],
            [lang === "ru" ? "Баннер объявления" : "Announcement Banner", "Welcome to Osu!Nya!", "text"],
          ].map(([lbl, def, type]) => (
            <div key={lbl} style={{ display: "flex", alignItems: "center", gap: 14, marginBottom: 14 }}>
              <label style={{ width: 260, fontSize: 12, color: "var(--muted)", flexShrink: 0 }}>{lbl}</label>
              <input type={type} defaultValue={def} style={{ padding: "7px 12px", flex: 1 }} />
            </div>
          ))}
          <div style={{ display: "flex", gap: 10, marginTop: 8 }}>
            <button className="btn-accent" style={{ padding: "8px 22px", fontSize: 13, borderRadius: 9 }}
              onClick={() => notify(lang === "ru" ? "Настройки сохранены!" : "Settings saved!")}>
              {at.save}
            </button>
            <button className="btn-ghost" style={{ padding: "8px 22px", fontSize: 13, borderRadius: 9 }}
              onClick={() => notify(lang === "ru" ? "Кеш очищен!" : "Cache cleared!")}>
              {at.clearCache}
            </button>
          </div>
        </div>
      )}

      {tab === "logs" && (
        <div className="card fu d3">
          <div style={{ padding: "14px 18px", borderBottom: "1px solid var(--border)", fontWeight: 700, fontSize: 14 }}>
            📋 {lang === "ru" ? "Системные логи" : "System Logs"}
            <span style={{ fontSize: 11, color: "var(--muted)", fontWeight: 400, marginLeft: 8 }}>{lang === "ru" ? "Последние 50" : "Last 50"}</span>
          </div>
          {[
            { time: "2026-02-25 14:32:11", level: "INFO",  msg: "User sakura_beats logged in from JP" },
            { time: "2026-02-25 14:30:55", level: "INFO",  msg: "Map catalog refreshed — 214,930 maps indexed" },
            { time: "2026-02-25 14:28:03", level: "WARN",  msg: "API rate limit hit for user xXstream_godXx" },
            { time: "2026-02-25 14:20:41", level: "ERROR", msg: "Failed to fetch osu! API — retry in 30s" },
            { time: "2026-02-25 14:15:00", level: "INFO",  msg: "Admin CamelliaMaster updated user role" },
            { time: "2026-02-25 13:55:19", level: "INFO",  msg: "Scheduled maintenance completed" },
            { time: "2026-02-25 13:40:02", level: "WARN",  msg: "Slow query detected — map search 2.3s" },
            { time: "2026-02-25 13:20:00", level: "INFO",  msg: "Daily stats snapshot saved" },
          ].map((l, i) => (
            <div key={i} style={{
              padding: "9px 18px", borderBottom: "1px solid var(--border)",
              display: "flex", gap: 14, alignItems: "center", fontFamily: "'JetBrains Mono',monospace", fontSize: 11
            }}>
              <span style={{ color: "var(--muted)", flexShrink: 0 }}>{l.time}</span>
              <span style={{
                padding: "1px 7px", borderRadius: 5, flexShrink: 0, fontWeight: 700,
                background: l.level === "ERROR" ? "rgba(248,113,113,0.15)" : l.level === "WARN" ? "rgba(251,191,36,0.15)" : "rgba(104,216,145,0.1)",
                color: l.level === "ERROR" ? "#f87171" : l.level === "WARN" ? "var(--amber)" : "#68d891",
              }}>{l.level}</span>
              <span style={{ color: "var(--text)", fontSize: 12, fontFamily: "'Space Grotesk',sans-serif" }}>{l.msg}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};


// ─────────────────────────────────────────────────────────────
// DIFF ROW
// ─────────────────────────────────────────────────────────────
const DiffRow = ({ diff, topPP, lang, onNotif }) => {
  const [ppData, setPpData] = useState(null);
  const [mods, setMods] = useState([]);
  const [loading, setLoading] = useState(false);
  const MOD_LIST = ["DT", "HD", "HR", "FL"];

  const toggleMod = (mod) => {
    setMods(prev => prev.includes(mod) ? prev.filter(m => m !== mod) : [...prev, mod]);
  };
  const modsKey = mods.slice().sort().join(',');
  useEffect(() => {
    if (!diff.id) return;
    fetchPP(mods);
  }, [modsKey]); // eslint-disable-line

  const fetchPP = useCallback(async (modsToUse) => {
    if (!diff.id) return;
    setLoading(true);
    try {
      const res = await fetch('/api/get-beatmap-pp', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ beatmapId: diff.id, mods: modsToUse ?? mods, accuracy: 97 }),
      });
      if (!res.ok) throw new Error('Failed');
      const data = await res.json();
      setPpData(data);
    } catch {
      onNotif('PP fetch failed');
    } finally {
      setLoading(false);
    }
  }, [diff.id, mods, onNotif]);

  useEffect(() => { fetchPP([]); }, []); // eslint-disable-line

  const stars  = ppData?.stars  ?? diff.difficulty_rating ?? 0;
  const pp     = ppData?.pp     ?? null;
  const ar     = ppData?.ar     ?? diff.ar ?? 0;
  const bpm    = ppData?.bpm    ?? null;
  const length = ppData?.length ?? (diff.hit_length
    ? `${Math.floor(diff.hit_length / 60)}:${String(diff.hit_length % 60).padStart(2, '0')}`
    : '—');

  const ppColor = () => {
    if (!pp || !topPP) return "var(--muted)";
    const d = pp - topPP;
    if (d > 50) return "#f87171";
    if (d > 0)  return "var(--amber)";
    if (d > -80) return "#68d891";
    return "#7eb8f7";
  };

  return (
    <div style={{
      display: "grid",
      gridTemplateColumns: "1fr auto auto auto auto auto",
      alignItems: "center", gap: 14,
      padding: "12px 20px",
      borderBottom: "1px solid rgba(255,255,255,0.05)",
    }}>
      {/* Название сложности + звёзды */}
      <div>
        <div style={{ fontWeight: 700, fontSize: 13 }}>{diff.version}</div>
        <div style={{ fontSize: 11, color: "var(--muted)", marginTop: 2 }}>
          {stars > 0 && <span style={{ color: "#ffb6d0" }}>✦ {(+stars).toFixed(2)}★</span>}
        </div>
      </div>
      {/* Моды — кнопки заняли место Calc PP, стали крупнее */}
      <div style={{ display: "flex", gap: 5 }}>
        {MOD_LIST.map(mod => (
          <button key={mod} onClick={() => toggleMod(mod)} style={{
            padding: "5px 11px", borderRadius: 8, border: "1px solid",
            fontSize: 11, fontWeight: 800, cursor: "pointer", fontFamily: "inherit",
            transition: "all 0.15s",
            borderColor: mods.includes(mod) ? "var(--a)" : "var(--border)",
            background:  mods.includes(mod) ? "var(--dim)" : "var(--bg2)",
            color:       mods.includes(mod) ? "var(--a)"   : "var(--muted)",
            minWidth: 38,
          }}>{loading && mods.includes(mod) ? "…" : mod}</button>
        ))}
      </div>
      {/* AR */}
      <div style={{ textAlign: "center", minWidth: 38 }}>
        <div style={{ fontSize: 10, color: "var(--muted)" }}>AR</div>
        <div className="mono" style={{ fontSize: 13, fontWeight: 700 }}>{ar}</div>
      </div>
      {/* BPM */}
      <div style={{ textAlign: "center", minWidth: 44 }}>
        <div style={{ fontSize: 10, color: "var(--muted)" }}>BPM</div>
        <div className="mono" style={{ fontSize: 13, fontWeight: 700 }}>{bpm ?? "—"}</div>
      </div>
      {/* Длина */}
      <div style={{ textAlign: "center", minWidth: 46 }}>
        <div style={{ fontSize: 10, color: "var(--muted)" }}>{lang === "ru" ? "Длина" : "Length"}</div>
        <div className="mono" style={{ fontSize: 13 }}>{length}</div>
      </div>
      {/* PP */}
      <div style={{ textAlign: "right", minWidth: 64 }}>
        {loading ? (
          <div style={{ fontSize: 12, color: "var(--muted)", animation: "softPulse 1s infinite" }}>…</div>
        ) : pp !== null ? (
          <div className="mono" style={{ fontSize: 17, fontWeight: 700, color: ppColor() }}>
            {pp}<span style={{ fontSize: 10, color: "var(--muted)" }}>pp</span>
          </div>
        ) : (
          <div style={{ fontSize: 12, color: "var(--muted)" }}>—</div>
        )}
      </div>
    </div>
  );
};


// ─────────────────────────────────────────────────────────────
// BEATMAP SET CARD
// ─────────────────────────────────────────────────────────────
const BeatmapSetCard = ({ m, topPP, lang, viewMode, onNotif }) => {
  const computedLength =
  m.beatmaps?.[0]?.hit_length
    ? `${Math.floor(m.beatmaps[0].hit_length / 60)}:${String(m.beatmaps[0].hit_length % 60).padStart(2,'0')}`
    : null;

  const [diffsModal, setDiffsModal] = useState(false);
  const { addToQueue, removeFromQueue, isInQueue } = useQueue();
  const { favMap, setFavMap } = useFavMap();

  const inQueue  = isInQueue(m.id);
  const hasDiffs = m.beatmaps && m.beatmaps.length > 0;

  const tier = (() => {
    const stars = m.stars || m.beatmaps?.[0]?.difficulty_rating || 0;
    if (m._starsAboveProfile !== undefined) {
      const d = m._starsAboveProfile;
      if (d > 1.0) return { l: lang==='ru'?'Хард':'Hard',       c:'#f87171',    bg:'rgba(248,113,113,0.15)' };
      if (d > 0.3) return { l: lang==='ru'?'Испытание':'Challenge', c:'var(--amber)', bg:'var(--amberDim)' };
      if (d >= 0)  return { l: lang==='ru'?'Фарм':'Farm',        c:'#68d891',    bg:'rgba(104,216,145,0.15)' };
    }
    if (stars > 7) return { l: lang==='ru'?'Хард':'Hard',        c:'#f87171',    bg:'rgba(248,113,113,0.15)' };
    if (stars > 6) return { l: lang==='ru'?'Испытание':'Challenge', c:'var(--amber)', bg:'var(--amberDim)' };
    if (stars > 5) return { l: lang==='ru'?'Фарм':'Farm',         c:'#68d891',    bg:'rgba(104,216,145,0.15)' };
    return           { l: lang==='ru'?'Лёгкое':'Comfortable',     c:'#7eb8f7',    bg:'rgba(126,184,247,0.15)' };
  })();

  const coverUrl = m.covers?.['card@2x'] || m.covers?.card || m.covers?.['list@2x'] || m.covers?.cover || m.cover || null;
  const isFav    = favMap?.id === String(m.beatmapSetId || m.id);

  const handleFav = (e) => {
    e.stopPropagation();
    if (isFav) {
      setFavMap(null);
    } else {
      setFavMap({
        id:        String(m.beatmapSetId || m.id),
        url:       `https://osu.ppy.sh/beatmapsets/${m.beatmapSetId || m.id}`,
        title:     m.title,
        artist:    m.artist,
        stars:     m.stars || m.beatmaps?.[0]?.difficulty_rating || null,
        bpm:       m.bpm || null,
        cover_url: coverUrl,
      });
    }
  };

  const handleQueue = (e) => {
    e.stopPropagation();
    if (inQueue) {
      removeFromQueue(m.id);
    } else {
      addToQueue({
        id:           m.id,
        beatmapSetId: m.beatmapSetId || m.id,
        title:        m.title,
        artist:       m.artist,
        mapper:       m.mapper || m.creator,
        stars:        m.stars || m.beatmaps?.[0]?.difficulty_rating || 0,
        bpm:          m.bpm,
        ar:           m.ar,
        length:       m.length,
        cover:        coverUrl,
      });
      onNotif && onNotif(`${m.title} ${lang==='ru'?'добавлена в очередь!':'added to queue!'}`);
    }
  };

  // ── Модалка с дифами ──────────────────────────────────────
  const DiffsModal = () => (
    <div style={{
      position:'fixed', inset:0, zIndex:3000,
      background:'rgba(0,0,0,0.82)', backdropFilter:'blur(8px)',
      display:'flex', alignItems:'center', justifyContent:'center',
    }} onClick={() => setDiffsModal(false)}>
      <div onClick={e => e.stopPropagation()} style={{
        width:'min(860px, 95vw)', maxHeight:'85vh',
        background:'var(--card2)', border:'1px solid var(--border)',
        borderRadius:20, boxShadow:'0 24px 80px rgba(0,0,0,0.7)',
        display:'flex', flexDirection:'column', overflow:'hidden',
      }}>
        {/* Header */}
        <div style={{
          padding:'16px 22px', borderBottom:'1px solid var(--border)',
          display:'flex', alignItems:'center', justifyContent:'space-between',
          background:'rgba(255,255,255,0.02)', borderRadius:'20px 20px 0 0',
          position:'sticky', top:0, backdropFilter:'blur(20px)', zIndex:10,
        }}>
          <div style={{ display:'flex', alignItems:'center', gap:14 }}>
            {coverUrl && (
              <div style={{ width:48, height:48, borderRadius:10, flexShrink:0, background:`url(${coverUrl}) center/cover`, border:'1px solid var(--border)' }} />
            )}
            <div>
              <div style={{ fontWeight:800, fontSize:15 }}>{m.title}</div>
              <div style={{ fontSize:11, color:'var(--muted)', marginTop:2 }}>
                {m.artist}
                {m.mapper && <> · mapped by <span style={{color:'var(--a3)'}}>{m.mapper || m.creator}</span></>}
                {' · '}{m.beatmaps.length} {lang==='ru'?'сложностей':'difficulties'}
              </div>
            </div>
          </div>
          <button onClick={() => setDiffsModal(false)} style={{
            background:'none', border:'none', color:'var(--muted)',
            cursor:'pointer', fontSize:24, lineHeight:1, padding:'0 4px', flexShrink:0,
          }}>×</button>
        </div>
        {/* Rows */}
        <div style={{ padding:'6px 0', overflowY:'auto', flex:1 }}>
          {m.beatmaps.map((diff, i) => (
            <DiffRow key={diff.id || i} diff={diff} topPP={topPP} lang={lang} onNotif={onNotif} />
          ))}
        </div>
      </div>
    </div>
  );

  // ── LIST VIEW ─────────────────────────────────────────────
  if (viewMode === 'list') {
    return (
      <>
        <tr style={{ cursor:'pointer' }}>
          <td onClick={() => window.open(`https://osu.ppy.sh/beatmapsets/${m.beatmapSetId || m.id}`, '_blank')}>
            <div style={{ fontWeight:700, fontSize:13, display:'flex', alignItems:'center', gap:6 }}>
              {m.title}<span style={{ fontSize:10, color:'var(--muted)', opacity:0.7 }}>↗</span>
            </div>
            <div style={{ fontSize:11, color:'var(--muted)' }}>{m.diff || m.creator} · {m.mapper || m.creator}</div>
          </td>
          <td onClick={() => window.open(`https://osu.ppy.sh/beatmapsets/${m.beatmapSetId || m.id}`, '_blank')}>
            <Stars v={+(m.stars || m.beatmaps?.[0]?.difficulty_rating || 0)} />
          </td>
          <td onClick={() => window.open(`https://osu.ppy.sh/beatmapsets/${m.beatmapSetId || m.id}`, '_blank')}>
            <span className="mono" style={{ color:'var(--a)', fontWeight:700 }}>{m.pp || '—'}</span>
          </td>
          <td className="mono" style={{ fontSize:12 }}>{m.bpm}</td>
          <td className="mono" style={{ fontSize:12 }}>{m.ar}</td>
          <td style={{ fontSize:12, color:'var(--muted)' }}>{computedLength || '—'}</td>
          <td>{m._starsAboveProfile !== undefined && <span style={{ background:tier.bg, color:tier.c, borderRadius:20, padding:'2px 10px', fontSize:10, fontWeight:700, whiteSpace:'nowrap' }}>{tier.l}</span>}</td>
          <td>
            <div style={{ display:'flex', gap:6 }}>
              {hasDiffs && (
                <button className="btn-ghost" style={{ padding:'4px 10px', fontSize:11, borderRadius:20 }}
                  onClick={e => { e.stopPropagation(); setDiffsModal(true); }}>
                  ▼ {m.beatmaps.length}
                </button>
              )}
              <button className="btn-accent" style={{ padding:'4px 12px', fontSize:11, borderRadius:20 }}
                onClick={handleQueue}>
                {inQueue ? (lang==='ru'?'✓ В очереди':'✓ Queued') : `+ ${lang==='ru'?'Очередь':'Queue'}`}
              </button>
            </div>
          </td>
        </tr>
        {diffsModal && <DiffsModal />}
      </>
    );
  }

  // ── GRID VIEW ─────────────────────────────────────────────
  return (
    <>
      <div className="card fu" style={{ overflow:'hidden', transition:'all 0.25s', display:'flex', flexDirection:'column' }}>
        {/* Cover */}
        <div style={{
          height:100,
          background: coverUrl ? `url(${coverUrl}) center/cover no-repeat` : `linear-gradient(135deg,${tier.bg},var(--bg2))`,
          position:'relative', overflow:'hidden', flexShrink:0, cursor:'pointer',
        }} onClick={() => window.open(`https://osu.ppy.sh/beatmapsets/${m.beatmapSetId || m.id}`, '_blank')}>
          {!coverUrl && (
            <>
              <div style={{ position:'absolute', inset:0, background:`linear-gradient(135deg,${tier.bg},var(--bg2))` }} />
              <span style={{ position:'absolute', top:'50%', left:'50%', transform:'translate(-50%,-50%)', fontSize:32, opacity:0.5 }}>♪</span>
            </>
          )}
          {coverUrl && <div style={{ position:'absolute', inset:0, background:'linear-gradient(to bottom, transparent 30%, rgba(10,8,20,0.85))' }} />}
          <div style={{ position:'absolute', top:8, right:8 }}>
            {m._starsAboveProfile !== undefined && (
              <span style={{ background:tier.bg, color:tier.c, borderRadius:20, padding:'2px 10px', fontSize:10, fontWeight:700, backdropFilter:'blur(4px)' }}>{tier.l}</span>
            )}
          </div>
          <span style={{ position:'absolute', bottom:6, right:10, fontSize:10, color:'rgba(255,255,255,0.5)' }}>osu! ↗</span>
        </div>

        {/* Info */}
        <div style={{ padding:'10px 14px', flex:1, cursor:'pointer' }}
          onClick={() => window.open(`https://osu.ppy.sh/beatmapsets/${m.beatmapSetId || m.id}`, '_blank')}>
          <div style={{ fontWeight:700, fontSize:13, whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis' }}>{m.title}</div>
          <div style={{ fontSize:11, color:'var(--muted)', marginTop:1 }}>by {m.artist}</div>
          <div style={{ fontSize:10, color:'var(--a3)', marginTop:1 }}>mapped by {m.mapper || m.creator}</div>
          <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginTop:8 }}>
            <Stars v={+(m.stars || m.beatmaps?.[0]?.difficulty_rating || 0)} />
            {m.pp && <span className="mono" style={{ color:'var(--a)', fontWeight:700, fontSize:14 }}>{m.pp}pp</span>}
          </div>
          <div style={{ display:'flex', gap:5, marginTop:6, flexWrap:'wrap' }}>
            {[m.ar && `AR ${m.ar}`, m.bpm && `BPM ${m.bpm}`, computedLength && `⏱ ${computedLength}`].filter(Boolean).map(tag => (
              <span key={tag} className="tag" style={{ fontSize:10 }}>{tag}</span>
            ))}
            {hasDiffs && (
              <span className="tag" style={{ fontSize:10, color:'var(--a3)' }}>
                {m.beatmaps.length} {lang==='ru'?'сложн.':'diffs'}
              </span>
            )}
          </div>
        </div>

        {/* Buttons */}
        <div style={{ padding:'0 12px 12px', display:'flex', gap:6 }}>
          <button onClick={handleFav}
            title={isFav ? (lang==='ru'?'Убрать из любимых':'Remove from favourites') : (lang==='ru'?'Любимая карта':'Set as favourite')}
            style={{
              padding:'6px 10px', fontSize:15, borderRadius:8, border:'1px solid',
              background: isFav ? 'rgba(248,113,113,0.15)' : 'var(--bg2)',
              borderColor: isFav ? 'rgba(248,113,113,0.5)' : 'var(--border)',
              color: isFav ? '#f87171' : 'var(--muted)',
              cursor:'pointer', transition:'all 0.15s', flexShrink:0,
            }}>
            {isFav ? '♥' : '♡'}
          </button>
          {hasDiffs && (
            <button className="btn-ghost" style={{ flex:1, padding:'6px', fontSize:11, borderRadius:8 }}
              onClick={() => setDiffsModal(true)}>
              ▼ {m.beatmaps.length} {lang==='ru'?'сл.':'diffs'}
            </button>
          )}
          <button className="btn-accent" style={{
            flex:1, padding:'6px', fontSize:11, borderRadius:8,
            background:  inQueue ? 'rgba(104,216,145,0.15)' : undefined,
            borderColor: inQueue ? 'rgba(104,216,145,0.4)'  : undefined,
            color:       inQueue ? '#68d891'                : undefined,
          }} onClick={handleQueue}>
            {inQueue ? '✓' : '+'} {inQueue ? (lang==='ru'?'В очереди':'Queued') : (lang==='ru'?'В очередь':'Queue')}
          </button>
        </div>
      </div>

      {/* Модалка с дифами — рендерится ВНЕ карточки, не сдвигает грид */}
      {diffsModal && <DiffsModal />}
    </>
  );
};


// ─────────────────────────────────────────────────────────────
// NumInput
// ─────────────────────────────────────────────────────────────
const NumInput = ({ label, value, onChange, min, max, step = 0.1 }) => {
  const handleChange = (e) => {
    const raw = e.target.value;
    if (raw === "" || raw === "-") { onChange(raw); return; }
    const n = parseFloat(raw);
    if (!isNaN(n)) onChange(n);
  };
  const handleBlur = () => {
    let n = parseFloat(value);
    if (isNaN(n)) { onChange(min ?? 0); return; }
    if (min !== undefined) n = Math.max(min, n);
    if (max !== undefined) n = Math.min(max, n);
    onChange(Math.round(n * 100) / 100);
  };
  const inc = () => { let n = (parseFloat(value) || 0) + step; if (max !== undefined) n = Math.min(max, n); onChange(Math.round(n * 100) / 100); };
  const dec = () => { let n = (parseFloat(value) || 0) - step; if (min !== undefined) n = Math.max(min, n); onChange(Math.round(n * 100) / 100); };
  const btnStyle = (extra) => ({ width: 26, height: 30, border: "1.5px solid var(--border)", background: "var(--card2)", color: "var(--text)", cursor: "pointer", fontSize: 14, fontWeight: 700, display: "flex", alignItems: "center", justifyContent: "center", ...extra });

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 4, minWidth: 90 }}>
      <label style={{ fontSize: 10, color: "var(--muted)", fontWeight: 700, textTransform: "uppercase", letterSpacing: 0.5 }}>{label}</label>
      <div style={{ display: "flex", alignItems: "center" }}>
        <button onClick={dec} style={btnStyle({ borderRight: "none", borderRadius: "8px 0 0 8px" })}>−</button>
        <input type="number" value={value} onChange={handleChange} onBlur={handleBlur} step={step} min={min} max={max}
          style={{ width: 56, height: 30, textAlign: "center", padding: "0 4px", borderRadius: 0, border: "1.5px solid var(--border)", fontSize: 13, fontFamily: "'Share Tech Mono',monospace", background: "var(--card2)", color: "var(--text)" }} />
        <button onClick={inc} style={btnStyle({ borderLeft: "none", borderRadius: "0 8px 8px 0" })}>+</button>
      </div>
    </div>
  );
};


// ─────────────────────────────────────────────────────────────
// MAP CATALOG
// ─────────────────────────────────────────────────────────────
export const MapCatalog = ({ user }) => {
  const { t, lang } = useLang();
  const mt = t.maps;
  const [activeTab, setActiveTab] = useState("catalog");
  const [notif, setNotif]         = useState(null);
  const notify = msg => { setNotif(msg); setTimeout(() => setNotif(null), 3000); };
  const { addToQueue, removeFromQueue, isInQueue } = useQueue();

  const topPP = user?.topPlay?.pp || user?.pp || 0;

  // ── Вкладка 1: Каталог ──────────────────────────────────────
  const [search, setSearch]           = useState("");
  const [sortBy, setSortBy]           = useState("plays_desc");
  const [status, setStatus]           = useState("ranked");
  const [viewMode, setViewMode]       = useState("grid");
  const [starsMin, setStarsMin]       = useState(1);
  const [starsMax, setStarsMax]       = useState(10);
  const [showFilters, setShowFilters] = useState(false);

  const [maps, setMaps]           = useState([]);
  const [loadingMaps, setLoadingMaps] = useState(false);
  const [hasMore, setHasMore]     = useState(true);

  // cursorString живёт в ref — не триггерит пересоздание fetchMaps
  // и не вызывает двойные запросы через IntersectionObserver
  const cursorRef    = useRef(null);
  const loadingRef   = useRef(false); // защита от двойного вызова
  const hasMoreRef   = useRef(true);
  const fetchMapsRef = useRef(null);
  const observerRef  = useRef(null);

  // Callback ref — цепляет observer каждый раз когда sentinel монтируется в DOM
  const sentinelRef = useCallback((node) => {
    if (observerRef.current) { observerRef.current.disconnect(); observerRef.current = null; }
    if (!node) return;
    observerRef.current = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && hasMoreRef.current && !loadingRef.current) {
          fetchMapsRef.current?.(false);
        }
      },
      { rootMargin: '600px' }
    );
    observerRef.current.observe(node);
  }, []);

  const fetchMaps = useCallback(async (reset = false) => {
    if (loadingRef.current) return; // уже грузим — пропускаем
    loadingRef.current = true;
    setLoadingMaps(true);
    try {
      // При поиске с текстом используем relevance — osu! API возвращает
      // точные совпадения первыми, а не просто самые играемые карты
      const effectiveSort = (search.trim() && sortBy === 'plays_desc') ? 'relevance' : sortBy;

      const params = new URLSearchParams({
        q:     search || "",
        s:     status,
        sort:  effectiveSort,
        limit: 20,
      });
      if (!reset && cursorRef.current) params.set("cursor_string", cursorRef.current);

      const res  = await fetch(`/api/search-maps?${params}`);
      const data = await res.json();
      const newMaps = data.beatmapsets || [];

      cursorRef.current = data.cursor_string || null;
      setMaps(prev => reset ? newMaps : [...prev, ...newMaps]);
      setHasMore(!!data.cursor_string && newMaps.length > 0);
    } catch (e) {
      notify(lang === "ru" ? "Ошибка загрузки карт" : "Failed to load maps");
    } finally {
      loadingRef.current = false;
      setLoadingMaps(false);
    }
  }, [search, sortBy, status, lang]); // cursorRef не нужен в deps — это ref

  // Синкаем refs с актуальными значениями
  useEffect(() => { fetchMapsRef.current = fetchMaps; }, [fetchMaps]);
  useEffect(() => { hasMoreRef.current = hasMore; }, [hasMore]);

  // Сброс и перезагрузка при смене параметров поиска
  useEffect(() => {
    if (activeTab !== "catalog") return;
    cursorRef.current = null; // сбрасываем курсор до fetchMaps
    const t = setTimeout(() => fetchMaps(true), search ? 400 : 0);
    return () => clearTimeout(t);
  }, [search, sortBy, status, activeTab]); // eslint-disable-line

  // Фильтрация по stars на фронте
  const filteredMaps = maps.filter(m => {
    const s = m.beatmaps?.[0]?.difficulty_rating ?? 0;
    return s >= starsMin && s <= starsMax;
  });

  // ── Вкладка 2: Maps For You ──────────────────────────────────
  const [recs, setRecs]             = useState([]);
  const [loadingRecs, setLoadingRecs] = useState(false);
  const [recsLoaded, setRecsLoaded]   = useState(false);
  const [recFilter, setRecFilter]   = useState("all");
  const [recsProfile, setRecsProfile] = useState(null);
  const [recVisible,  setRecVisible]  = useState(20);   // сколько рекомендаций показываем
  const recSentinelRef = useRef(null);                   // sentinel для инфинит скролла рекомендаций

  const fetchRecs = useCallback(async () => {
    if (!user?.id) { notify(lang === "ru" ? "Нужна авторизация" : "Login required"); return; }
    setLoadingRecs(true);
    try {
      const session = JSON.parse(localStorage.getItem('osu_session') || '{}');
      const res = await fetch('/api/get-recommendations', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          userId:         user.id,
          accessToken:    session.accessToken || undefined,
          // Передаём данные сессии — best + recent — для более точных рекомендаций
          bestPlays:      user.bestPlays      || [],
          recentActivity: user.recentActivity || [],
        }),
      });
      const data = await res.json();
      setRecs(data.recommendations || []);
      setRecsProfile(data.profile || null);
      setRecsLoaded(true);
    } catch {
      notify(lang === "ru" ? "Ошибка загрузки рекомендаций" : "Failed to load recommendations");
    } finally {
      setLoadingRecs(false);
    }
  }, [user, lang]);

  useEffect(() => {
    if (activeTab === "foryou" && !recsLoaded && !loadingRecs) {
      fetchRecs();
    }
  }, [activeTab]); // eslint-disable-line

  const recLabels = {
    all:       lang === "ru" ? "Все"        : "All",
    comfort:   lang === "ru" ? "Комфорт"    : "Comfort",
    challenge: lang === "ru" ? "Испытание"  : "Challenge",
  };

  const filteredRecs = recFilter === "all"
    ? recs
    : recs.filter(r => r._label === recFilter);

  // Сбрасываем видимые при смене фильтра
  const prevRecFilter = React.useRef(recFilter);
  if (prevRecFilter.current !== recFilter) {
    prevRecFilter.current = recFilter;
    if (recVisible !== 20) setRecVisible(20);
  }

  const visibleRecs   = filteredRecs.slice(0, recVisible);
  const recHasMore    = recVisible < filteredRecs.length;

  // IntersectionObserver для рекомендаций
  React.useEffect(() => {
    const sentinel = recSentinelRef.current;
    if (!sentinel) return;
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && recHasMore) {
          setRecVisible(v => v + 20);
        }
      },
      { rootMargin: '400px' }
    );
    observer.observe(sentinel);
    return () => observer.disconnect();
  }, [recHasMore]);

  // Грубая оценка PP по звёздам (97% acc, no mods)
  const estimatePP = (stars) => {
    const s = +stars || 0;
    if (s < 3)   return '<50';
    if (s < 3.5) return '50-80';
    if (s < 4)   return '80-120';
    if (s < 4.5) return '120-170';
    if (s < 5)   return '170-230';
    if (s < 5.5) return '230-310';
    if (s < 6)   return '310-430';
    if (s < 6.5) return '430-580';
    if (s < 7)   return '580-760';
    if (s < 7.5) return '760-950';
    return '950+';
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 18 }}>
      {notif && <Notif msg={notif} onClose={() => setNotif(null)} />}

      {/* ── Вкладки ── */}
      <div className="fu" style={{ display: "flex", gap: 8 }}>
        {[
          { id: "catalog", label: `♪ ${lang === "ru" ? "Каталог" : "Catalog"}` },
          { id: "foryou",  label: `⊙ ${lang === "ru" ? "Для тебя" : "For You"}` },
        ].map(tab => (
          <button key={tab.id} onClick={() => setActiveTab(tab.id)}
            className={activeTab === tab.id ? "btn-accent" : "btn-ghost"}
            style={{ padding: "8px 20px", fontSize: 13, borderRadius: 10 }}>
            {tab.label}
          </button>
        ))}
      </div>

      {/* ══════════════════════════════════════════════════════════
          ВКЛАДКА 1: КАТАЛОГ
      ══════════════════════════════════════════════════════════ */}
      {activeTab === "catalog" && (
        <>
          <div className="card fu" style={{ padding: 20 }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 10 }}>
              <div>
                <h2 className="syne" style={{ fontSize: 20, fontWeight: 800 }}>♪ {mt.title}</h2>
                <p style={{ fontSize: 12, color: "var(--muted)", marginTop: 3 }}>
                  {lang === "ru" ? "Поиск по каталогу osu!" : "Searching the osu! catalog"}
                </p>
              </div>
              <div style={{ display: "flex", gap: 8 }}>
                <button onClick={() => setShowFilters(v => !v)} className="btn-ghost"
                  style={{ padding: "6px 14px", fontSize: 12, borderRadius: 8, borderColor: showFilters ? "var(--a)" : "var(--border)", color: showFilters ? "var(--a)" : "var(--muted)" }}>
                  ⚙ {lang === "ru" ? "Фильтры" : "Filters"}
                </button>
                {[["grid", "⊞"], ["list", "≡"]].map(([v, ic]) => (
                  <button key={v} onClick={() => setViewMode(v)} className="btn-ghost"
                    style={{ padding: "6px 12px", fontSize: 14, borderRadius: 8, background: viewMode === v ? "var(--dim)" : "transparent", borderColor: viewMode === v ? "var(--a)" : "var(--border)", color: viewMode === v ? "var(--a)" : "var(--muted)" }}>
                    {ic}
                  </button>
                ))}
              </div>
            </div>

            <div style={{ display: "flex", gap: 10, marginTop: 14, flexWrap: "wrap" }}>
              <input placeholder={`🔍 ${mt.search}`} value={search} onChange={e => setSearch(e.target.value)}
                style={{ padding: "8px 14px", flex: 1, minWidth: 200 }} />
              <select value={sortBy} onChange={e => setSortBy(e.target.value)} style={{ padding: "8px 12px", cursor: "pointer" }}>
                <option value="plays_desc">{lang === "ru" ? "По популярности" : "Most Played"}</option>
                <option value="favourites_desc">{lang === "ru" ? "По избранным" : "Most Favourited"}</option>
                <option value="ranked_desc">{lang === "ru" ? "Новые ranked" : "Recently Ranked"}</option>
                <option value="difficulty_desc">{lang === "ru" ? "Сложные первые" : "Hardest First"}</option>
                <option value="difficulty_asc">{lang === "ru" ? "Лёгкие первые" : "Easiest First"}</option>
              </select>
              <select value={status} onChange={e => setStatus(e.target.value)} style={{ padding: "8px 12px", cursor: "pointer" }}>
                <option value="ranked">Ranked</option>
                <option value="loved">Loved</option>
                <option value="qualified">Qualified</option>
                <option value="any">{lang === "ru" ? "Все статусы" : "Any Status"}</option>
              </select>
            </div>

            {showFilters && (
              <div style={{ marginTop: 16, padding: "16px 18px", background: "var(--bg2)", borderRadius: 14, border: "1px solid var(--border)", display: "flex", gap: 24, flexWrap: "wrap", alignItems: "flex-end" }}>
                <NumInput label={lang === "ru" ? "★ Мин" : "★ Min"} value={starsMin} onChange={v => setStarsMin(Math.max(0.5, v))} min={0.5} max={15} step={0.5} />
                <NumInput label={lang === "ru" ? "★ Макс" : "★ Max"} value={starsMax} onChange={v => setStarsMax(Math.min(15, v))} min={0.5} max={15} step={0.5} />
                <button onClick={() => { setStarsMin(1); setStarsMax(10); }}
                  className="btn-ghost" style={{ padding: "6px 14px", fontSize: 11, borderRadius: 8, alignSelf: "flex-end" }}>
                  {lang === "ru" ? "Сбросить" : "Reset"}
                </button>
              </div>
            )}
          </div>

          <div style={{ fontSize: 12, color: "var(--muted)" }} className="fu d1">
            {mt.showing} <span style={{ color: "var(--a)", fontWeight: 700 }}>{filteredMaps.length}</span> {mt.maps}
            {loadingMaps && <span style={{ marginLeft: 8, opacity: 0.6 }}>⏳</span>}
          </div>

          {loadingMaps && maps.length === 0 ? (
            <div style={{ textAlign: "center", padding: 60, color: "var(--muted)" }}>
              <div style={{ width: 40, height: 40, border: "3px solid var(--border)", borderTopColor: "var(--a)", borderRadius: "50%", animation: "spin 1s linear infinite", margin: "0 auto 16px" }} />
              {lang === "ru" ? "Загрузка карт..." : "Loading maps..."}
            </div>
          ) : viewMode === "grid" ? (
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(280px,1fr))", gap: 14 }}>
              {filteredMaps.map((m, i) => (
                <BeatmapSetCard key={`${m.id}-${i}`} m={m} topPP={topPP} lang={lang} viewMode="grid" onNotif={notify} />
              ))}
              {/* Sentinel для инфинит скролла */}
              <div ref={sentinelRef} style={{ gridColumn: "1 / -1", height: 1 }} />
            </div>
          ) : (
            <div className="card fu d2">
              <table>
                <thead><tr>
                  <th>{lang === "ru" ? "Карта" : "Map"}</th>
                  <th>{lang === "ru" ? "Звёзды" : "Stars"}</th>
                  <th>PP</th><th>BPM</th><th>AR</th>
                  <th>{lang === "ru" ? "Длина" : "Length"}</th>
                  <th>{lang === "ru" ? "Уровень" : "Tier"}</th>
                  <th></th>
                </tr></thead>
                <tbody>
                  {filteredMaps.map((m, i) => (
                    <BeatmapSetCard key={`${m.id}-${i}`} m={m} topPP={topPP} lang={lang} viewMode="list" onNotif={notify} />
                  ))}
                </tbody>
              </table>
              {/* Sentinel для list режима */}
              <div ref={sentinelRef} style={{ height: 1 }} />
            </div>
          )}

          {/* Спиннер подгрузки (вместо кнопки "Load More") */}
          {loadingMaps && maps.length > 0 && (
            <div style={{ textAlign: "center", padding: "16px 0", color: "var(--muted)", display: "flex", alignItems: "center", justifyContent: "center", gap: 10 }}>
              <div style={{ width: 20, height: 20, border: "2px solid var(--border)", borderTopColor: "var(--a)", borderRadius: "50%", animation: "spin 0.8s linear infinite" }} />
              <span style={{ fontSize: 13 }}>{lang === "ru" ? "Загружаем ещё..." : "Loading more..."}</span>
            </div>
          )}

          {/* Конец каталога */}
          {!hasMore && maps.length > 0 && !loadingMaps && (
            <div style={{ textAlign: "center", padding: "12px 0", fontSize: 12, color: "var(--muted)" }}>
              {lang === "ru" ? "✓ Все карты загружены" : "✓ All maps loaded"}
            </div>
          )}
        </>
      )}

      {/* ══════════════════════════════════════════════════════════
          ВКЛАДКА 2: MAPS FOR YOU
      ══════════════════════════════════════════════════════════ */}
      {activeTab === "foryou" && (
        <>
          <div className="card fu" style={{ padding: 20 }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 10 }}>
              <div>
                <h2 className="syne" style={{ fontSize: 20, fontWeight: 800 }}>⊙ {lang === "ru" ? "Карты для тебя" : "Maps For You"}</h2>
                <p style={{ fontSize: 12, color: "var(--muted)", marginTop: 3 }}>
                  {lang === "ru"
                    ? "На основе топ игр, последних сессий и твоего стиля игры"
                    : "Based on your top plays, recent sessions and playstyle"}
                  {topPP > 0 && <> — <span style={{ color: "var(--a)", fontWeight: 700 }}>{topPP}pp</span></>}
                </p>
              </div>
              <button className="btn-accent" style={{ padding: "8px 18px", fontSize: 12, borderRadius: 10 }}
                onClick={fetchRecs} disabled={loadingRecs}>
                {loadingRecs ? "⏳" : (lang === "ru" ? "↻ Обновить" : "↻ Refresh")}
              </button>
            </div>

            {/* Мини-статистика профиля (после загрузки) */}
            {recsProfile && (
              <div style={{ display: "flex", gap: 12, marginTop: 14, flexWrap: "wrap" }}>
                {[
                  { l: lang === "ru" ? "Медиана ★" : "Median ★",   v: recsProfile.medStars,       c: "#ffb6d0" },
                  { l: lang === "ru" ? "Сейчас фармит ★" : "Current farm ★", v: recsProfile.recentMedStars, c: "#68d891" },
                  { l: lang === "ru" ? "Топ PP" : "Top PP",         v: `${Math.round(recsProfile.topPP)}pp`, c: "var(--a)" },
                  { l: lang === "ru" ? "Точность" : "Avg Acc",      v: `${recsProfile.avgAcc}%`,   c: "#7eb8f7" },
                  recsProfile.favMods?.length > 0 && {
                    l: lang === "ru" ? "Любимые моды" : "Fav mods",
                    v: recsProfile.favMods.slice(0, 3).join(' '),
                    c: "#a78bfa"
                  },
                ].filter(Boolean).map((s, i) => (
                  <div key={i} style={{
                    padding: "7px 14px", borderRadius: 10, background: "var(--bg2)",
                    border: "1px solid var(--border)", fontSize: 12,
                  }}>
                    <span style={{ color: "var(--muted)", fontSize: 10 }}>{s.l} </span>
                    <span style={{ fontWeight: 700, color: s.c }}>{s.v}</span>
                  </div>
                ))}
                {recsProfile.dataSource && (
                  <div style={{
                    padding: "7px 14px", borderRadius: 10, background: "var(--bg2)",
                    border: "1px solid var(--border)", fontSize: 11, color: "var(--muted)",
                  }}>
                    {recsProfile.dataSource === 'api+session'
                      ? `⊙ ${recsProfile.totalScoresParsed} ${lang === "ru" ? "игр проанализировано" : "scores analysed"}`
                      : `⊙ ${lang === "ru" ? "Только данные сессии" : "Session data only"}`}
                  </div>
                )}
              </div>
            )}

            {/* Фильтры категорий */}
            {recsLoaded && (
              <div style={{ display: "flex", gap: 8, marginTop: 14, flexWrap: "wrap" }}>
                {Object.entries(recLabels).map(([k, v]) => (
                  <button key={k} onClick={() => setRecFilter(k)} style={{
                    padding: "3px 14px", borderRadius: 20, border: "1px solid",
                    borderColor: recFilter === k ? "var(--a)" : "var(--border)",
                    background:  recFilter === k ? "var(--a)" : "var(--card2)",
                    color:       recFilter === k ? "var(--bg)" : "var(--muted)",
                    cursor: "pointer", fontFamily: "inherit", fontSize: 12, fontWeight: 600, transition: "all 0.2s",
                  }}>{v}</button>
                ))}
              </div>
            )}
          </div>

          {loadingRecs && (
            <div style={{ textAlign: "center", padding: 60, color: "var(--muted)" }}>
              <div style={{ width: 40, height: 40, border: "3px solid var(--border)", borderTopColor: "var(--a)", borderRadius: "50%", animation: "spin 1s linear infinite", margin: "0 auto 16px" }} />
              <div>{lang === "ru" ? "Анализируем твои игры..." : "Analysing your plays..."}</div>
              <div style={{ fontSize: 12, marginTop: 8, opacity: 0.6 }}>
                {lang === "ru" ? "Используем топ + последние игры + моды" : "Using top plays + recent sessions + mods"}
              </div>
            </div>
          )}

          {!loadingRecs && !recsLoaded && (
            <div style={{ textAlign: "center", padding: 60, color: "var(--muted)" }}>
              <div style={{ fontSize: 40, marginBottom: 16 }}>⊙</div>
              <div style={{ fontWeight: 700, marginBottom: 8 }}>{lang === "ru" ? "Рекомендации не загружены" : "Recommendations not loaded"}</div>
              <div style={{ fontSize: 13, marginBottom: 20 }}>
                {lang === "ru" ? "Нажми Обновить — анализируем топ + недавние игры + стиль" : "Click Refresh — we'll analyse top plays + recent sessions + playstyle"}
              </div>
            </div>
          )}

          {!loadingRecs && recsLoaded && filteredRecs.length === 0 && (
            <div style={{ textAlign: "center", padding: 40, color: "var(--muted)", fontSize: 13 }}>
              {lang === "ru" ? "Нет карт в этой категории" : "No maps in this category"}
            </div>
          )}

          {!loadingRecs && filteredRecs.length > 0 && (
            <>
              <div style={{ fontSize: 12, color: "var(--muted)" }} className="fu d1">
                {lang === "ru" ? "Показано" : "Showing"}{" "}
                <span style={{ color: "var(--a)", fontWeight: 700 }}>{visibleRecs.length}</span>
                {" / "}
                <span style={{ color: "var(--a)", fontWeight: 700 }}>{filteredRecs.length}</span>
                {" "}{lang === "ru" ? "рекомендаций" : "recommendations"}
              </div>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(280px,1fr))", gap: 14 }}>
                {visibleRecs.map((m, i) => {
                  const ppRange = estimatePP(m.stars);
                  const inQ = isInQueue(m.id);
                  const labelStyle = {
                    fontSize: 10, fontWeight: 700, padding: "2px 8px", borderRadius: 12,
                    background: m._label === "comfort"   ? "rgba(104,216,145,0.2)"
                              : m._label === "challenge" ? "rgba(251,191,36,0.2)"
                              : "rgba(186,140,255,0.2)",
                    color:      m._label === "comfort"   ? "#68d891"
                              : m._label === "challenge" ? "var(--amber)"
                              : "#ba8cff",
                  };
                  return (
                    <div key={`rec-${m.id}-${i}`} className="card fu" style={{ overflow: "hidden", display: "flex", flexDirection: "column" }}>
                      {/* Cover */}
                      <div style={{
                        height: 88,
                        background: m.cover ? `url(${m.cover}) center/cover` : "linear-gradient(135deg,var(--dim),var(--bg2))",
                        position: "relative", overflow: "hidden", flexShrink: 0, cursor: "pointer",
                      }} onClick={() => window.open(`https://osu.ppy.sh/beatmapsets/${m.beatmapSetId || m.id}`, "_blank")}>
                        {m.cover && <div style={{ position: "absolute", inset: 0, background: "linear-gradient(to bottom,transparent 30%,rgba(0,0,0,0.75))" }} />}
                        {!m.cover && <span style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%,-50%)", fontSize: 28, opacity: 0.5 }}>♪</span>}
                        <div style={{ position: "absolute", top: 8, left: 8 }}>
                          <span style={labelStyle}>{recLabels[m._label] || m._label}</span>
                        </div>
                        <span style={{ position: "absolute", bottom: 6, right: 10, fontSize: 10, color: "rgba(255,255,255,0.5)" }}>osu! ↗</span>
                      </div>

                      {/* Info */}
                      <div style={{ padding: "10px 14px", flex: 1, cursor: "pointer" }}
                        onClick={() => window.open(`https://osu.ppy.sh/beatmapsets/${m.beatmapSetId || m.id}`, "_blank")}>
                        <div style={{ fontWeight: 700, fontSize: 13, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{m.title}</div>
                        <div style={{ fontSize: 11, color: "var(--muted)", marginTop: 1 }}>{m.artist}</div>
                        <div style={{ fontSize: 10, color: "var(--a3)", marginTop: 1 }}>by {m.mapper}</div>

                        {/* Stars + PP estimate */}
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginTop: 8 }}>
                          <Stars v={+(m.stars || 0)} />
                          <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
                            {m._starsAboveProfile > 0 && (
                              <span style={{ fontSize: 10, color: "var(--amber)" }}>+{m._starsAboveProfile.toFixed(1)}★</span>
                            )}
                            {/* PP estimate badge */}
                            <span style={{
                              fontSize: 11, fontWeight: 700, fontFamily: "'Share Tech Mono',monospace",
                              padding: "2px 7px", borderRadius: 8,
                              background: "rgba(186,140,255,0.12)", border: "1px solid rgba(186,140,255,0.25)",
                              color: "#ba8cff",
                            }}>~{ppRange}pp</span>
                          </div>
                        </div>

                        {/* Tags */}
                        <div style={{ display: "flex", gap: 5, marginTop: 6, flexWrap: "wrap" }}>
                          {[m.ar && `AR ${m.ar}`, m.bpm && `BPM ${m.bpm}`, m.length && `⏱ ${m.length}`].filter(Boolean).map(tag => (
                            <span key={tag} className="tag" style={{ fontSize: 10 }}>{tag}</span>
                          ))}
                        </div>
                      </div>

                      {/* Queue button */}
                      <div style={{ padding: "0 14px 12px" }}>
                        <button className="btn-accent" style={{
                          width: "100%", padding: "7px", fontSize: 11, borderRadius: 8,
                          background: inQ ? "rgba(104,216,145,0.15)" : undefined,
                          borderColor: inQ ? "rgba(104,216,145,0.4)" : undefined,
                          color: inQ ? "#68d891" : undefined,
                        }} onClick={() => {
                          if (inQ) { removeFromQueue(m.id); }
                          else {
                            addToQueue({ id: m.id, beatmapSetId: m.beatmapSetId || m.id, title: m.title, artist: m.artist, mapper: m.mapper, stars: m.stars || 0, bpm: m.bpm, ar: m.ar, length: m.length, cover: m.cover || null });
                            notify(`${m.title} ${lang === "ru" ? "добавлена в очередь!" : "added to queue!"}`);
                          }
                        }}>
                          {inQ ? (lang === "ru" ? "✓ В очереди" : "✓ Queued") : `+ ${lang === "ru" ? "В очередь" : "Queue"}`}
                        </button>
                      </div>
                    </div>
                  );
                })}

                {/* Sentinel — подгружает следующие 20 */}
                <div ref={recSentinelRef} style={{ gridColumn: "1 / -1", height: 1 }} />
              </div>

              {/* Спиннер подгрузки рекомендаций */}
              {recHasMore && (
                <div style={{ textAlign: "center", padding: "14px 0", color: "var(--muted)", display: "flex", alignItems: "center", justifyContent: "center", gap: 10 }}>
                  <div style={{ width: 18, height: 18, border: "2px solid var(--border)", borderTopColor: "var(--a)", borderRadius: "50%", animation: "spin 0.8s linear infinite" }} />
                  <span style={{ fontSize: 12 }}>{lang === "ru" ? "Загружаем ещё..." : "Loading more..."}</span>
                </div>
              )}
            </>
          )}
        </>
      )}
    </div>
  );
};